var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.125,
    cy: 8.125,
    r: 7.125,
    fill: "#F8B400",
    fillOpacity: 0.37
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.875,
    cy: 8.125,
    r: 7.125,
    stroke: "#005555",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2501 6.54073H6.27855C6.27855 5.55478 6.88845 4.96067 7.86907 4.96067C8.83773 4.96067 9.45959 5.5927 9.45959 6.60393C9.45959 8.13343 8.29959 8.41152 6.93629 8.41152H6.58948L6.63732 10.4087H7.58206L7.61794 9.20787C9.29216 9.20787 10.5 8.44944 10.5 6.60393C10.5 4.9986 9.42371 4 7.85711 4C6.29051 4 5.23814 5.01124 5.2501 6.54073ZM7.82124 12.2163C7.82124 11.7739 7.49835 11.4326 7.10371 11.4326C6.68515 11.4326 6.36227 11.7739 6.36227 12.2163C6.36227 12.6587 6.68515 13 7.10371 13C7.49835 13 7.82124 12.6587 7.82124 12.2163Z",
    fill: "#005555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4b4c70b18cef6f21cf2a5f87715bfe8f.svg";
export { ForwardRef as ReactComponent };